import { mapActions } from 'vuex'
import PassengerPaymentMediasService from 'js/services/api/passenger/payment-medias.js'

import template from './_recharge-data.pug'

const emailRegExp = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i

const RECHARGE_MAX_LIMIT = 300000

export default Vue.extend({
  name: 'recharge-data',
  template: template(),
  props: {
    text: {
      type: String,
      default: undefined
    },
    emailIsNecessary: {
      type: Boolean,
      default: true
    },
    formData: {
      type: Object,
      default() {
        return {
          amount: undefined,
          email: undefined,
          accept_conditions: false,
          media_code: undefined,
          media_type: undefined,
          administrative_area_code: undefined
        }
      }
    },
    products: {
      type: Array,
      default: () => undefined
    },
    productErrors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // Datos
      productPriceSelected: undefined,
      product_item_code: undefined,
      productsPrice: undefined,
      amount: undefined,
      email: undefined,
      accept_conditions: false,
      // Errores
      amountError: undefined,
      emailError: undefined,
      acceptConditionsError: undefined,
      // Modal de condiciones de servicio
      modal: false,
      minAllowedValuelimit: null,
      prechargesCode: null,
      enableContinue: true,
      // Filtros
      onlyNumbers: (oldValue, value) => {
        value = this.stringWithoutSymbols(value)
        if (value === '') return ''
        if (value && String(value).trim().match(/^[0-9]+$/)) {
          return String(value).trim()
        }
        return String(oldValue).trim()
      },
      trim: (oldValue, value) => String(value).trim(),
      inRange: {
        args: [RECHARGE_MAX_LIMIT],
        function: (oldValue, value, max) => {
          if (value === '') return ''

          // Tal y como se especifica la documentacion
          // los argumentos seran recibidos en formato de cadena
          // luego necesitamos convertirlo a numero
          const originalValue = this.stringWithoutSymbols(value)
          value = Number(this.stringWithoutSymbols(value))

          // Para evitar problemas raros
          if (Number.isNaN(value)) return oldValue

          if (value >= Number.parseFloat(this.minAllowedValuelimit) &&
              value <= Number.parseFloat(max)) {
            return originalValue
          }
          return oldValue
        }
      },
      formatInput: (_oldValue, value) => {
        if (value === '') return ''
        value = this.transformInputAmount(value)

        return this.$options.filters.moverickCurrencyOnlyInteger(value.toString())
      },
      dataBrands: undefined,
      showTextGCmaxAmoutRechargue: false,
    }
  },
  computed: {
    formattedProductErrors() {
      // Formatea segun error de producto
      const errors = this.productErrors
      const errorMessages = []

      if (errors?.support_type) {
        errorMessages.push(errors.support_type)
      }

      if (errors?.period_type) {
        errorMessages.push(errors.period_type)
      }

      if (errors?.product_instance_code) {
        errorMessages.push(errors.product_instance_code)
      }

      if (errors?.support_instance_code) {
        errorMessages.push(errors.support_instance_code)
      }

      return errorMessages.join(', ')
    },
    cardResponse() {
      // Verifica si es recarga de saldo o producto
      return localStorage.getItem('cardResponse') === 'true'
    },
    setPrice() {
      // Selecciona precio del producto si estos existen
      const products = this.products
      if (products.length === undefined || products.length === 0) return

      // eslint-disable-next-line consistent-return
      return products?.map(product => ({
        label: product?.name,
        value: product?.price,
        code: product?.product_entity_code,
        expendable: product?.is_expendable,
        period: product?.is_in_recharge_period
      }))
    },

    validEmail() {
      const vm = this

      if (vm.email) {
        if (emailRegExp.test(vm.email)) {
          return true
        }
        return false
      }
      return false
    },
    config() {
      return this.administrativeArea.config
    },
    shouldSelectPaymentPlatform() {
      return this.paymentPlatforms.length > 0
    },
    continueButtonDisabled() {
      if (this.cardResponse) {
        // Condiciones adicionales si es recarga de producto
        if (this.productsPrice === undefined) return true
        if (this.dataBrands === undefined) return true

        return this.shouldSelectPaymentPlatform && !this.dataBrands
      }

      return this.shouldSelectPaymentPlatform && !this.dataBrands
    }
  },
  async created() {
    this.initializeRechargeParams()
    this.email = this.formData.email
    this.accept_conditions = this.formData.accept_conditions
    await this.getAppConfigCode()
  },
  methods: {
    ...mapActions('appConfig', [
      '/loadAppConfig'
    ]),

    handleCheckboxChange(selectedValue) {
      this.productsPrice = this.$options.filters.moverickCurrency(selectedValue.value)
      this.amount = this.productsPrice
      this.product_item_code = selectedValue.code

      // Actualiza formData para incluir product_item_code
      this.$set(this.formData, 'product_item_code', this.product_item_code)
    },

    checkRecharge() {
      this.productPriceSelected = this.productsPrice || null
      const vm = this
      vm.acceptConditionsError = undefined
      vm.emailError = undefined
      vm.amountError = undefined

      const params = {
        administrative_area_code: vm.formData.administrative_area_code,
        media_type: vm.formData.media_type,
        media_code: vm.formData.media_code,
        type: 4,
        recharge_amount: this.transformInputAmount(this.amount),
        product_item_code: this.product_item_code || null
      }

      if (vm.validateFields()) {
        PassengerPaymentMediasService.preRecharge({ params }).then((response) => {
          if (response?.external_request_data?.prechargesCode) {
            vm.prechargesCode = response?.external_request_data?.prechargesCode;
          }
          vm.advance()
        }, response => {
          const expectedError = [-2, -19, -30, -31, -32].indexOf(response.data.data) !== -1
          let errorText = ''

          switch (response.data.data) {
            case -2:
              errorText = this.$t(
                'recharge.rechargeData.balanceMustBePositive',
                { min: this.formatedAmount(response.data.min) }
              )
              break
            case -19:
              errorText = vm.$t('recharge.rechargeData.everilionPendingPrechargesLimitReached')
              break
            case -30:
              errorText = vm.$t(
                'recharge.rechargeData.everilionAmountError',
                { max: this.formatedAmount(response.data.max) }
              )
              break
            case -31:
              errorText = vm.$t('recharge.rechargeData.mediaBalanceExceded')
              break
            case -32:
              errorText = `(${response.body.external_request_data.response}) ${response.body.external_request_data.error}`
              this.enableContinue = false
              break
            default:
              errorText = vm.$t('recharge.rechargeData.preRechargeError')
              break
          }

          if (expectedError) {
            vm.amountError = errorText
          }

          const { errors } = response.data

          if (errors && errors.administrative_area === 'forbids_action') {
            errorText = this.$t('recharge.rechargeData.forbidenError')
          }

          vm.$notifications.send({
            id: 'pre-recharge-error',
            text: errorText,
            type: 'error',
            close: true
          })
        })
      }
    },
    validateFields() {
      const vm = this
      let bool = true

      if (!vm.validEmail && this.emailIsNecessary) {
        vm.emailError = vm.$t('recharge.rechargeData.emailError')
        bool = false
      }
      if (!vm.accept_conditions) {
        vm.acceptConditionsError = vm.$t('recharge.rechargeData.acceptConditionsError')
        bool = false
      }
      if (isNaN(this.stringWithoutSymbols(vm.amount))) {
        vm.amountError = vm.$t(
          'recharge.rechargeData.amountError', { value: vm.formatedAmount(vm.minAllowedValuelimit) }
        )
        bool = false
      } else if (
        this.transformInputAmount(vm.amount) < this.minAllowedValuelimit && !this.cardResponse
      ) {
        bool = false
        vm.amountError = vm.$t(
          'recharge.rechargeData.amountError', { value: vm.formatedAmount(vm.minAllowedValuelimit) }
        )
      }

      return bool
    },
    advance() {
      // Actualiza amount si es recarga de producto
      if (this.productsPrice) { this.amount = this.productsPrice }

      const extraformData = {
        amount: this.transformInputAmount(this.amount),
        email: this.email,
        accept_conditions: this.accept_conditions,
        product_item_code: this.product_item_code || null,
        external_precharge_id: this.prechargesCode || null
      }

      // Si es recarga de producto ejecuta una validación de productos antes de next step
      if (this.cardResponse) {
        this.$emit('advanceProduct', extraformData, this.dataBrands)
      } else {
        this.$emit('advance', extraformData, this.dataBrands)
      }
    },
    back() {
      this.$emit('back')
    },
    showModal() {
      if (this.$currentAppConfig.code === 'gc') {
        const routeData = 'https://autgc.org/aviso-legal/'
        window.open(routeData)
      } else {
        this.modal = true
      }
    },
    closeModal() {
      this.modal = false
    },
    initializeRechargeParams() {
      const compensation_center = this.administrativeArea.compensation_center
      const amount = compensation_center.default_recharge_amount.toString()

      const hasCustomAmount =
        this.formData.amount !== undefined &&
        this.formData.amount !== null &&
        this.formData.amount !== 500

      if (hasCustomAmount) {
        if (!this.cardResponse) {
          this.amount = this.$options.filters.moverickCurrencyOnlyInteger(
            this.formData.amount
          )
        } else {
          this.amount = this.formData.amount.toString()
        }
      } else if (this.productsPrice) {
        this.amount = this.productsPrice
      } else {
        this.amount = this.$options.filters.moverickCurrencyOnlyInteger(amount)
      }
      this.minAllowedValuelimit = compensation_center.minimum_recharge_amount
    },
    /**
     * Removes all non-digit characters from the input and returns a string of only digits.
     * Used as the numeric input filter for fields (replaces onlyNumbers data property).
     * Returns '' if no digits found.
     * @param {string|number} value
     * @returns {string}
     *
     * Examples:
     *   "abc123xyz" => "123"
     *   "€5.000,12" => "500012"
     */
    stringWithoutSymbols(value) {
      const cleaned = String(value).replace(/\D/g, '');
      return cleaned;
    },
    formatedAmount(amount) {
      return this.$options.filters.moverickCurrency(amount)
    },
    transformInputAmount(amount) {
      const numericAmount = typeof (amount) === 'string' ?
        parseInt(this.stringWithoutSymbols(amount)) : amount

      return this.cardResponse ? numericAmount : numericAmount * 10 ** this.config.decimals_count
    },

    /** @todo Is this API call necessary? The config should already be loaded in VUEX */
    async getAppConfigCode() {
      if (_.isEmpty(this.currentAppConfig)) {
        await this.loadAppConfig()
      }

      this.showTextGCmaxAmoutRechargue = this.appCode === "gc"
    },
    handleDeleteKeys(event) {
      if (event.keyCode === 8 || event.keyCode === 46) {
        event.preventDefault()
        this.handleCustomDeletion()
      }
    },
    handleCustomDeletion() {
      let currentValue = this.amount.toString().replace(/[^0-9]/g, '');

      let newValue = currentValue.slice(0, -1);
      let value = this.transformInputAmount(newValue)
      if (isNaN(value)) {
        value = ""
      }
      this.amount = this.$options.filters.moverickCurrencyOnlyInteger(value.toString())
    }
  }
})
